import { PressRelease } from 'ui/components';

export const PressReleaseFeature: React.FC = () => {
	return <PressRelease />;
};
